import * as React from "react";
import ImgHeader from "./ImgHeader";
import FeatureGrid from "./FeatureGrid";
import { H1 } from "./Headers";
import ScrollToTopOnMount from "./ScrollToTopOnMount";
import WithHelperBar from "./WithHelperBar";

const Home = () => (
  <>
    <ScrollToTopOnMount />
    <ImgHeader url="/static/img/Home.png" shadowOpacity={0.01}>
      <H1>
        Skyward API Resources
        <br /> for Partners
      </H1>
    </ImgHeader>

    <WithHelperBar>
      <FeatureGrid />
    </WithHelperBar>
  </>
);

export default Home;
